import { IS_LOADING, NOT_LOADING, SET_CONFIG } from './constants';

const configSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  properties: {
    site: {
      type: ['string', 'null'],
    },
    user: {
      type: ['string', 'null'],
    },
    visualsList: {
      items: {
        properties: {
          id: {
            type: 'string',
            minLength: 1,
          },
          isPublic: {
            default: false,
            type: 'boolean',
          },
          name: {
            type: 'string',
            minLength: 1,
          },
          thumbnail: {
            type: 'string',
          },
          url: {
            type: 'string',
            minLength: 1,
          },
        },
        required: ['id', 'name', 'url', 'isPublic'],
        type: 'object',
      },
      type: 'array',
      uniqueItems: true,
    },
  },
  type: 'object',
};

const initialState = {
  loading: false,
  config: {},
  configSchema,
};

const configReducer = (state: any, action: any) => {
  const { config } = action.payload || {};
  switch (action.type) {
    case IS_LOADING:
      return { ...state, loading: true };
    case NOT_LOADING:
      return { ...state, loading: false };
    case SET_CONFIG:
      return {
        ...state,
        config,
        loading: false,
      };
    default:
      return state;
  }
};

export { initialState, configReducer };
